import { api } from './api';

/** Código del enlace personal del conductor (/c/<código>), guardado hasta registrarse o iniciar sesión. */
const KEY = 'tcrd:driver-code';
const MAX_AGE_MS = 30 * 86_400_000;

export function storeDriverCode(code: string) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code: code.toLowerCase().slice(0, 40), at: Date.now() }));
  } catch {
    /* sin almacenamiento */
  }
}

export function storedDriverCode(): string | undefined {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? 'null') as { code: string; at: number } | null;
    return v && Date.now() - v.at < MAX_AGE_MS ? v.code : undefined;
  } catch {
    return undefined;
  }
}

export function clearDriverCode() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* sin almacenamiento */
  }
}

/** Cliente que ya tenía cuenta e inicia sesión desde el enlace: queda con ese conductor (si no tenía uno). */
export async function linkStoredDriver(roles: string[] | undefined) {
  const code = storedDriverCode();
  if (!code || !roles?.includes('CUSTOMER')) return;
  await api('/customers/me/driver', { body: { code } }).catch(() => undefined);
  clearDriverCode();
}
